import { SxProps } from "@mui/system"
import React, { FC } from "react"
import styled from "styled-components"

interface CarouselProps {
  autoPlay?: boolean
  interval?: number
  animation?: "fade" | "slide" | undefined
  index?: number
  indicators?: boolean
  onChange?: (index: number) => void
  children: any
  sx?: SxProps
}
export const CarouselItemWrapper = styled.div<{ selected: boolean }>`
  max-height: ${({ selected }) => (selected ? `inherit` : `0`)};
  opacity: ${({ selected }) => (selected ? `100%` : `0`)};
  position: relative;
  top: 0;
  right: 0;

  left: ${({ selected }) => (selected ? `0` : `100%`)};
  right: ${({ selected }) => (selected ? `0` : `-100%`)};
  transition: all
    ${({ selected }) => (selected ? `0.75s ease-in` : `0.25s ease-out`)};
  transition-property: opacity, left, right, max-height;
  overflow: hidden;
`

export const CarouselWrapper = styled.div`
  overflow: hidden;
`
